module.exports = __webpack_public_path__ + "img/newsimg3.46f305a0.jpg";